import { usePostHog } from "posthog-js/react";
import { createAnalytics } from "@/lib/analytics/index";

export interface UserProperties {
  role?: string;
  profileNickname?: string;
  telegramId?: string | number;
  isVerified?: boolean;
  subscriptionExpiry?: string;
  [key: string]: unknown;
}

export interface EventProperties {
  [key: string]: unknown;
}

export const useAnalytics = () => {
  const posthog = usePostHog();
  const client = createAnalytics(posthog);

  return {
    identifyUser: client.identify.bind(client),
    trackEvent: client.track.bind(client),
    flushAnalytics: client.flush?.bind(client),
    posthog,
  };
};
